module.exports = __webpack_public_path__ + "img/las-reservas2.188e034c.png";